<template>
  <div class="sf_hide" v-if="isStoreFont & !isUser" @click="handleSfHide" />
</template>

<script>
import { getLocalStorage } from '@/utils/localStorage';
import storeFont from '@/utils/storefont';
import passportMonitor from '@/utils/passportMonitor';
import { mapState } from 'vuex';
export default {
  name: 'SfHide',
  props: {},
  data() {
    return {};
  },
  computed: {
    ...mapState('common', ['sidebar']),

    isUser() {
      return getLocalStorage('isLogin') || this.phone;
    },
    phone() {
      return this.sidebar?.selfInfo?.phone || '';
    },
    isStoreFont() {
      return storeFont.isStoreFont();
    },
  },
  mounted() {},
  methods: {
    handleSfHide() {
      passportMonitor.login();
    },
  },
};
</script>

<style lang="scss" scoped>
.sf_hide {
  position: fixed;
  font-size: 50px;
  width: 100vw;
  min-height: 100vh;
  height: 100%;
  z-index: 500;
  cursor: pointer;
  top: 0;
  left: 0;
}
</style>